(ns manatee.admin.rejection-option.handlers
  (:require [ajax.core :refer [json-request-format]]
            [kee-frame.core :as kf]
            [manatee.admin.rejection-option.app-db :as rejection-db]
            [manatee.ajax :as ajax]
            [manatee.components.notifications.handlers :as notifications]
            [re-frame.core :as rf]
            [taoensso.timbre :as log]))

(kf/reg-chain
 ::load-rejection-options
 (fn load-rejection-options
   [_ _]
   {:http-xhrio {:method :get
                 :uri (kf/path-for [:api/rejection-options])
                 :on-failure [::load-rejection-options-failure]
                 :response-format (ajax/edn-response-format)}})
 (fn load-rejection-options-success
   [{:keys [db]} [options]]
   {:db (rejection-db/set-rejection-options db options)}))

(kf/reg-chain
 ::load-rejection-options-failure
 (fn load-rejection-options-failure
   [_ [_ info]]
   (log/error "Error loading rejection-options" {:info info})
   {:dispatch [::notifications/add-alert :main
               {:message "Unable to load rejection options"
                :type :error}
               :auto-dismiss? false]}))

(kf/reg-chain
 ::add-rejection
 [(rf/inject-cofx :cookie/get [:auth-token])]
 (fn add-rejection
   [{:keys [db]} [rejection-option]]
   {:db db
    :http-xhrio {:method :post
                 :uri (kf/path-for [:api/rejection-options])
                 :params rejection-option
                 :format (json-request-format)
                 :response-format (ajax/edn-response-format)
                 :on-success [::add-rejection-success]
                 :on-failure [::add-rejection-failure]}}))

(kf/reg-chain
 ::add-rejection-success
 (fn add-rejection-success
   [{:keys [db]} [_]]
   {:db db
    :dispatch-n [[::load-rejection-options]
                 [::notifications/add-alert :main
                  {:message "Rejection added successfully"
                   :type :info}
                  :auto-dismiss? true]]}))

(kf/reg-chain
 ::add-rejection-failure
 (fn add-rejection-failure
   [{:keys [db]} [_ {:keys [response] :as _resp}]]
   {:db db
    :dispatch [::notifications/add-alert :main
               {:message (or (get-in response [:reason :message])
                             "Unable to add rejection")
                :type :error}
               :auto-dismiss? true]}))

(kf/reg-chain
 ::update-rejection
 [(rf/inject-cofx :cookie/get [:auth-token])]
 (fn update-rejection
   [{:keys [db]} [rejection-option rejection-option-id]]
   {:db db
    :http-xhrio {:method :put
                 :uri (kf/path-for [:api/rejection-options])
                 :params (assoc rejection-option :id (str rejection-option-id))
                 :format (json-request-format)
                 :response-format (ajax/edn-response-format)
                 :on-success [::update-rejection-success]
                 :on-failure [::update-rejection-failure]}}))

(kf/reg-chain
 ::update-rejection-success
 (fn update-rejection-success
   [{:keys [db]} [_ _]]
   {:db db
    :dispatch-n [[::load-rejection-options]
                 [::notifications/add-alert :main
                  {:message "Rejection updated successfully"
                   :type :info}
                  :auto-dismiss? true]]}))

(kf/reg-chain
 ::update-rejection-failure
 (fn update-rejection-failure
   [{:keys [db]} [_ {:keys [response] :as _resp}]]
   {:db db
    :dispatch [::notifications/add-alert :main
               {:message (or (get-in response [:reason :message])
                             "Unable to update rejection")
                :type :error}
               :auto-dismiss? true]}))

(kf/reg-event-db
 ::set-rejection-option
 (fn set-rejection-option
   [db [id]]
   (rejection-db/set-selected-rejection-option-id db id)))

(kf/reg-event-db
 ::set-list-view
 (fn set-list-view
   [db [flag]]
   (rejection-db/set-list-view db flag)))
